"use strict";

// Feature flag to enable/disable bundle properties
const BUNDLE_PROPERTIES_ENABLED = false; // Set to true to re-enable bundle functionality

document.addEventListener("DOMContentLoaded", () => {
  const updateProductOriginPrice = (newPrice) => {
    const productPrice = document.querySelector(`.product-info__price[data-bundle-set="true"] sale-price`);
    if (!productPrice) return;

    productPrice.textContent = `$${newPrice}`;
  };

  const initBundle = () => {
    const bundleSet = document.querySelector("#bundleSet");
    if (!bundleSet) return;

    const bundleProducts = bundleSet.querySelectorAll('input[type="checkbox"]');

    const bundleSetParent = bundleSet.closest("product-rerender");
    const quantitySelector = bundleSetParent.querySelector(".product-info__quantity-selector select");
    const bundleInfo = document.getElementById("bundleSetInfo");
    const mainProductInfo = bundleInfo.querySelector(".render-main-product-js");
    const bundleSetInfo = bundleInfo.querySelector(".render-selected-variant-js");

    const bundleSetPrice = document.getElementById("bundleSetPrice");
    const bundleMainPrice = parseFloat(bundleSetPrice.dataset.mainPrice.replace(/[$,]/gu, ""));
    const bundleIDS = document.getElementById("_bundleIDS");

    const defaultMainPrice = 0;

    const toggleVisibleBundleInfo = (selectedNames) => {
      const infoBundleSet = document.querySelector(".info-bundle-set");
      selectedNames.length ? infoBundleSet.classList.remove("hidden") : infoBundleSet.classList.add("hidden");
    };

    const updateBundleInfo = () => {
      const selectedNames = [];
      const selectedIds = [];
      let totalPrice = parseFloat(bundleMainPrice) || parseFloat(defaultMainPrice);

      bundleProducts.forEach((productCheckbox) => {
        const hint = productCheckbox.parentElement.querySelector(".hint");

        if (productCheckbox.checked) {
          selectedNames.push(`<span>‘${productCheckbox.dataset.title.trim()}’</span>`);

          const productPrice = parseFloat(productCheckbox.dataset.price.replace(/\$/gu, "")) || 0;

          totalPrice += productPrice;
          selectedIds.push(productCheckbox.dataset.id);
          hint.textContent = hint.dataset.textAdded;
        } else {
          hint.textContent = hint.dataset.textAdd;
        }
      });

      mainProductInfo.innerHTML = `
                ‘<span>${quantitySelector.value > 1 ? `${quantitySelector.value} ` : ""}${mainProductInfo.getAttribute("data-title")}</span>’ and'
            `;

      const totalAUPrice = totalPrice.toLocaleString("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      bundleSetInfo.innerHTML = selectedNames.join(" and ");
      bundleSetPrice.value = totalAUPrice;
      bundleIDS.value = selectedIds.join(",");

      updateProductOriginPrice(totalAUPrice);
      toggleVisibleBundleInfo(selectedNames);
    };

    bundleProducts.forEach((productCheckbox) => {
      productCheckbox.addEventListener("change", updateBundleInfo);
    });

    quantitySelector.addEventListener("change", updateBundleInfo);

    const initBundleAddToCart = () => {
      const addToCartButton = bundleSetParent.querySelector("#bundleBuyButton");

      if (!addToCartButton) return;

      function generateUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/gu,
          // eslint-disable-next-line func-names
          function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        );
      }

      addToCartButton.addEventListener("click", async () => {
        const selectedIds = bundleIDS.value.length > 0 ? bundleIDS.value.split(",") : [];
        const bundleTocken = generateUUID();

        const mainItem = {
          id: bundleIDS.dataset.mainId,
          quantity: +quantitySelector.value || 1,
        };

        if (BUNDLE_PROPERTIES_ENABLED) {
          mainItem.properties = {
            _bundleAllIds: bundleIDS.dataset.allIds,
            _bundleIncludedIds: selectedIds.join(","),
            _bundleUUID: bundleTocken,
          };
        }

        const formData = {
          items: [mainItem],
        };

        if (selectedIds.length > 0) {
          selectedIds.forEach((id) => {
            const bundleItem = {
              id,
              quantity: 1,
            };

            if (BUNDLE_PROPERTIES_ENABLED) {
              bundleItem.properties = {
                _bundleMainId: bundleIDS.dataset.mainId,
                _bundleUUID: bundleTocken,
              };
            }

            formData.items.push(bundleItem);
          });
        }

        addToCartButton.textContent = addToCartButton.dataset.loadingText;

        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          body: JSON.stringify(formData),
          headers: {
            "Content-Type": "application/json",
          },
          method: "POST",
        })
          .then(() => {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
            document.querySelector(`store-header [href="/cart"]`).click();
          })
          .catch((error) => {
            console.error("Error:", error);
          });

        addToCartButton.textContent = addToCartButton.dataset.normalText;
      });
    };

    initBundleAddToCart();
    updateBundleInfo();
  };

  initBundle();
});
